module.exports = __webpack_public_path__ + "static/media/police.40861aa7.svg";